import React from 'react';
import If from './If';
import ThemableSvgIcon from "./theme/ThemableSvgIcon";

class Modal extends React.Component {
    render() {
        if(!this.props.show) {
            return null;
        }

        return (
            <div className="fixed inset-0 z-50 overflow-auto bg-smoke-dark flex items-center">
                <div className="relative bg-white w-full md:max-w-md m-auto min-h-full md:min-h-0 md:h-auto flex-col flex">
                    {/* modal header */}
                    <div className="bg-primary-lighter px-4 py-2 text-xl flex items-center justify-between">
                        <span className="uppercase text-primary-dark">
                            {this.props.title}
                        </span>
                        <If test={!this.props.removeDissmissButton}>
                            <div className="inline text-primary-light cursor-pointer" onClick={this.props.onClose}>
                                <ThemableSvgIcon name="x" className="w-4 h-4"/>
                            </div>
                        </If>
                    </div>

                    {/* modal content */}
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default Modal;